
import React from 'react';

export function useActivityFormState() {
  // Activity specific states
  const [difficultyLevel, setDifficultyLevel] = React.useState('');
  const [duration, setDuration] = React.useState('');
  const [equipmentNeeded, setEquipmentNeeded] = React.useState('');
  const [maxGroupSize, setMaxGroupSize] = React.useState('');
  const [minAge, setMinAge] = React.useState('');
  const [suitableForChildren, setSuitableForChildren] = React.useState(false);
  const [weatherDependent, setWeatherDependent] = React.useState(false);

  const resetActivityFormState = () => {
    setDifficultyLevel('');
    setDuration('');
    setEquipmentNeeded('');
    setMaxGroupSize('');
    setMinAge('');
    setSuitableForChildren(false);
    setWeatherDependent(false);
  };

  return {
    difficultyLevel, setDifficultyLevel,
    duration, setDuration,
    equipmentNeeded, setEquipmentNeeded,
    maxGroupSize, setMaxGroupSize,
    minAge, setMinAge,
    suitableForChildren, setSuitableForChildren,
    weatherDependent, setWeatherDependent,
    resetActivityFormState
  };
}
